<template>
  <span class="booked-offer">
    <span v-if="offer.status === 'REP_PREBOOKED'">
      <el-link
        type="primary"
        :href="offer.url"
        target="_blank"
        class="booked-offer--link">
        <span class="booked-offer--link--bold">{{ offer.mover.name }}</span>
        {{ offerLabel }}
      </el-link>
    </span>
    <span v-else class="booked-offer--border-bottom">
      {{ offer.mover.name }}
      <template v-if="isActiveStep">
        : {{ $t('comparator.offers.offer.validationPreparation') }}</template>
    </span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'bookedOffer',
  props: {
    isActiveStep: Boolean,
    offer: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      demandStore: 'demandStore/demand',
      projectSelected: 'projectStore/projectSelected',
    }),
    exclTax() {
      return this.demandStore.show_price_ht;
    },
    offerLabel() {
      if (this.hidePriceInfo) {
        return '';
      }
      const price = offersHelper.getPrice(this.offer, this.exclTax);
      return `${this.$t('base.to')} ${this.$n(price, 'currency')} ${this.$tc('base.priceType', this.exclTax)}`;
    },
    hidePriceInfo() {
      return this.projectSelected && this.projectSelected.params.hide_price_info;
    },
    date() {
      return this.$d(new Date(this.offer.prebooked_until), 'short');
    },
  },
};
</script>

<style scoped lang="scss">
.booked-offer {
  &--border-bottom {
    border-bottom: solid 1px $--color-secondary;
  }

  &--link {
    margin-right: 10px;
    font-size: 18px;
    &--bold {
      font-weight: 600;
    }
  }
}
</style>
